import { SESSION_FEEDBACK_TYPE_TUTOR } from '@/queries/constants'
import SeriesQ from '@/queries/SeriesQ'
import SessionFeedbackQ from '@/queries/SessionFeedbackQ'
import SessionQ from '@/queries/SessionQ'
import SessionTemplateQ from '@/queries/SessionTemplateQ'
import WorldQ from '@/queries/WorldQ'
import { SQL, type SQLFragment } from '@/client/query'
import { HIGHLY_ENGAGING_SESSION_TALK_TIME_PERCENTAGE } from '@/client/services/session'

import {
  ALGEBRA2_LEARNING_LABS_WORLD_SLUG,
  COLLEGE_ADMISSIONS_WORKSHOPS_WORLD_SLUG,
  PRE_CALCULUS_LEARNING_LABS_WORLD_SLUG,
} from '../worlds'
import type { AutoGeneratedSeriesTag } from './constants'
import { SeriesTag as SeriesTagType } from './types'

const HIGH_QUALITY_BOOTCAMP_MIN_SESSIONS = 7
const HIGH_QUALITY_PROGRAM_MIN_NPS = 8
const HIGH_QUALITY_PROGRAMS_MAX_SESSION_MISSES = 1

const getHighlyEngagingProgramQuery = (worldSlug: string): SQLFragment<boolean> => SQL`(
  EXISTS(SELECT 1 ${WorldQ.where({
    slug: worldSlug,
    id: SeriesQ.world_id,
  })})
  AND (SELECT COUNT(*) >=
    (${SessionTemplateQ.countSessionTemplatesForSeriesTemplate({
      seriesTemplateId: SeriesQ.series_template_id,
    })} - ${HIGH_QUALITY_PROGRAMS_MAX_SESSION_MISSES})
   ${SessionQ.where({
     seriesId: SeriesQ.id,
     attemptedHosting: true,
   })}
  ) AND (SELECT
      COALESCE(AVG(${SessionFeedbackQ.nps}) >= ${HIGH_QUALITY_PROGRAM_MIN_NPS}, TRUE)
      ${SessionFeedbackQ.where(
        {
          include: [
            {
              association: 'Session',
              required: true,
              where: SQL`${SessionQ.series_id} = ${SeriesQ.id}`,
            },
          ],
          type: SESSION_FEEDBACK_TYPE_TUTOR,
        },
        SQL`${SessionFeedbackQ.nps} IS NOT NULL`
      )}) AND
  COALESCE(${SeriesQ.getTotalTutorSpeakingPercentage()}, 0) BETWEEN 0 AND ${HIGHLY_ENGAGING_SESSION_TALK_TIME_PERCENTAGE}
)`

// TODO: refactor the bootcamp tag to match the programs tag. Functionally they are the same
export const SERIES_TAG_TO_QUERY: Record<AutoGeneratedSeriesTag, SQLFragment<boolean>> = {
  [SeriesTagType.HighlyEngagingSATBootcamp]: SQL`(
    ${SeriesQ.isSATSeries()} AND
    (SELECT COUNT(*) >= ${HIGH_QUALITY_BOOTCAMP_MIN_SESSIONS} ${SessionQ.where({
      seriesId: SeriesQ.id,
      attemptedHosting: true,
    })}) AND
    (SELECT
        COALESCE(AVG(${SessionFeedbackQ.nps}) >= ${HIGH_QUALITY_PROGRAM_MIN_NPS}, TRUE)
        ${SessionFeedbackQ.where(
          {
            include: [
              {
                association: 'Session',
                required: true,
                where: SQL`${SessionQ.series_id} = ${SeriesQ.id}`,
              },
            ],
            type: SESSION_FEEDBACK_TYPE_TUTOR,
          },
          SQL`${SessionFeedbackQ.nps} IS NOT NULL`
        )}) AND
    COALESCE(${SeriesQ.getTotalTutorSpeakingPercentage()}, 0) BETWEEN 0 AND ${HIGHLY_ENGAGING_SESSION_TALK_TIME_PERCENTAGE}
  )`,
  [SeriesTagType.HighlyEngagingCollegeAdmissionsWorkshop]: getHighlyEngagingProgramQuery(
    COLLEGE_ADMISSIONS_WORKSHOPS_WORLD_SLUG
  ),
  [SeriesTagType.HighlyEngagingAlgebra2LearningLab]: getHighlyEngagingProgramQuery(
    ALGEBRA2_LEARNING_LABS_WORLD_SLUG
  ),
  [SeriesTagType.HighlyEngagingPreCalculusLearningLab]: getHighlyEngagingProgramQuery(
    PRE_CALCULUS_LEARNING_LABS_WORLD_SLUG
  ),
} as const
